import styled from "styled-components"

const PostMeta = styled.div`
  position: absolute;
  inset: var(--padding-vertical) var(--padding-horizontal);
  z-index: var(--max-z-index);
`

export default PostMeta
